import { useCallback, useEffect, useState } from 'react';

const useNavigateSuggestions = (
  listSize: number,
  onEnterKeyDown: (index: number) => void,
): number => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleKeyDown = useCallback<(event: KeyboardEvent) => void>(
    (event) => {
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        setActiveIndex((prevIndex) =>
          prevIndex > 0 ? prevIndex - 1 : listSize - 1,
        );
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        setActiveIndex((prevIndex) =>
          prevIndex < listSize - 1 ? prevIndex + 1 : 0,
        );
      }

      if (event.key === 'Enter' && listSize > 0 && activeIndex <= listSize) {
        event.preventDefault();
        onEnterKeyDown(activeIndex);
      }
    },
    [activeIndex, listSize, onEnterKeyDown],
  );

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown, false);
    return () => {
      window.removeEventListener('keydown', handleKeyDown, false);
    };
  }, [handleKeyDown]);

  return activeIndex;
};

export default useNavigateSuggestions;
